// extracted by mini-css-extract-plugin
export default {"padding":"Explore_padding__gpj9m","explorecard":"Explore_explorecard__zCw61","explorebtn":"Explore_explorebtn__5Dd7X","title":"Explore_title__NhmJe","grey":"Explore_grey__7zwKj"};